import React from 'react'
import styled from 'styled-components'
import performAction from '../actions'
import extractColor from '../helpers/extract-color'

Point = (props)->
	{point, config, originalPoint, card, color, demo} = props
	{label, value, href} = point
	{icon, size, top, action} = config
	
	handleClick = (e)->
		props.handleClick?(originalPoint)
		return e.preventDefault() if demo
		if action
			e.preventDefault()
			performAction(action, card)
	
	<Wrapper href={href} color={color} onClick={handleClick}>
		<Icon size={size} topoffset={top} dangerouslySetInnerHTML={__html:icon}></Icon>
		<Label>{label}</Label>
		<Value>{value}</Value>
	</Wrapper>


PlaceholderPoint = ({card, color, alwaysVisible, handleClick})->
	<Wrapper isBlank={!alwaysVisible} color={color} onClick={(e)-> handleClick?('placeholder')}>
		<PlaceholderWrapper alwaysVisible={alwaysVisible}>
			<Icon size={30} topoffset={3}>{"J"}</Icon>
			<Label>{"Add Contact Point"}</Label>
			<Value>{"Tap to add"}</Value>
		</PlaceholderWrapper>
	</Wrapper>


Wrapper = styled.a"""
	box-sizing: border-box
	position: relative
	display: block
	width: 50%
	padding: 80px 10px 30px;
	background-color: #e6e6e6
	border-bottom: 1px solid #d9dadc;
	text-align: center
	cursor: pointer
	user-select: none
	color: #141414
	
	&:nth-child(odd) {
		border-right: 1px solid #d9dadc;
	}

	&:hover {
		color: white
		background: linear-gradient(#{({color})->
			{gradient, direction} = extractColor(color)
			return "45deg, #{gradient[0]}, #{gradient[1]}"
		});
		
		@media(max-width:812px) {
			#{({isBlank})-> if isBlank then 'background: #e6e6e6'}
		}
	}
"""

PlaceholderWrapper = styled.div"""
	opacity: 0
	#{({alwaysVisible})-> if alwaysVisible then 'opacity: 1'}
	
	#{Wrapper}:hover & {
		opacity: 1

		@media(max-width:812px) {
			opacity: #{({alwaysVisible})-> if alwaysVisible then 1 else 0}
		}
	}
"""

Icon = styled.i"""
	position: absolute
	top: 25px
	left: 0
	right: 0
	display: block
	font-size: #{({size})-> "#{size}px"}
	#{({topoffset})-> if topoffset then "margin-top: #{topoffset}px"}
"""

Label = styled.div"""
	font-size: 11px
	font-family: gotham
	font-weight: 600
	text-transform: uppercase
	letter-spacing: #{40/1e3}em
"""

Value = styled.div"""
	margin-top: 4px
	font-size: 12px
	font-weight: 400
"""


export {PlaceholderPoint}
export default Point